import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import type { OverSiteControllerPeopleNumType } from "../_hooks/use-over-site-controller-people-num-type";

type Props = {
	overSiteControllerPeopleNumType: OverSiteControllerPeopleNumType;
	onSetOverSiteControllerPeopleNumType: (input: OverSiteControllerPeopleNumType) => void;
	overSiteControllerPeopleNumTypeOptions: {
		id: string;
		label: string;
		value: OverSiteControllerPeopleNumType;
	}[];
};

export const QuestionRoomOverSiteControllerPeopleNumType = ({
	onSetOverSiteControllerPeopleNumType: _onSetOverSiteControllerPeopleNumType,
	overSiteControllerPeopleNumType,
	overSiteControllerPeopleNumTypeOptions,
}: Props) => {
	const onSetOverSiteControllerPeopleNumType = (input: string) => {
		_onSetOverSiteControllerPeopleNumType(input as OverSiteControllerPeopleNumType);
	};

	return (
		<RadioGroupField
			value={overSiteControllerPeopleNumType ?? ""}
			options={overSiteControllerPeopleNumTypeOptions}
			handleValueChange={onSetOverSiteControllerPeopleNumType}
		/>
	);
};

QuestionRoomOverSiteControllerPeopleNumType.displayName = "QuestionRoomOverSiteControllerPeopleNumType";
